import { render, staticRenderFns } from "./contractDetailHisRoomFee.vue?vue&type=template&id=f87197c2&scoped=true"
import script from "./contractDetailHisRoomFee.vue?vue&type=script&lang=js"
export * from "./contractDetailHisRoomFee.vue?vue&type=script&lang=js"
import style0 from "./contractDetailHisRoomFee.vue?vue&type=style&index=0&id=f87197c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87197c2",
  null
  
)

export default component.exports